import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    // Create iframe element
    const iframe = document.createElement('iframe');
    iframe.id = 'chatbase-iframe';
    iframe.src = `https://www.chatbase.co/chatbot-iframe/${import.meta.env.VITE_CHATBASE_BOT_ID}`;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.position = 'fixed';
    iframe.style.bottom = '100px';
    iframe.style.right = '20px';
    iframe.style.border = 'none';
    iframe.style.borderRadius = '10px';
    iframe.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
    iframe.style.zIndex = '9999';
    iframe.style.maxWidth = '400px';
    iframe.style.maxHeight = '600px';
    iframe.style.backgroundColor = 'white';
    iframe.style.transition = 'all 0.3s ease-in-out';
    iframe.style.transform = 'translateY(20px)';
    iframe.style.opacity = '0';

    // Add style to hide Chatbase branding
    const style = document.createElement('style');
    style.textContent = `
      #chatbase-iframe {
        height: calc(100% - 100px) !important;
      }
      #chatbase-iframe::before {
        content: '';
        position: fixed;
        bottom: 100px;
        right: 20px;
        width: 400px;
        height: 30px;
        background: white;
        z-index: 10000;
      }
      .chatbase-bubble-img, 
      .chatbase-powered-by,
      [class*="powered-by"] {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);

    // Load Chatbase script with explicit HTTPS
    const script = document.createElement('script');
    script.src = 'https://www.chatbase.co/embed.min.js';
    script.defer = true;
    script.id = 'chatbase-widget-script';
    
    // Initialize chatbot when script loads
    script.onload = () => {
      if (window.Chatbase) {
        window.Chatbase.initFrame({
          chatbotId: import.meta.env.VITE_CHATBASE_BOT_ID,
          domain: 'www.chatbase.co',
          embedConfig: {
            hideBranding: true,
            hideAttribution: true
          }
        });
      }
      // Animate in
      setTimeout(() => {
        iframe.style.transform = 'translateY(0)';
        iframe.style.opacity = '1';
      }, 100);
    };

    document.body.appendChild(iframe);
    document.head.appendChild(script);

    // Cleanup
    return () => {
      const existingScript = document.getElementById('chatbase-widget-script');
      const existingIframe = document.getElementById('chatbase-iframe');
      const existingStyle = document.querySelector('style');
      
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
      if (existingIframe) {
        document.body.removeChild(existingIframe);
      }
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, [isOpen]);

  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col items-end gap-4">
      {isOpen && (
        <button
          onClick={() => setIsOpen(false)}
          className="flex items-center justify-center w-12 h-12 rounded-full bg-red-500 text-white shadow-lg hover:bg-red-600 transition-colors"
        >
          <X size={24} />
        </button>
      )}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-[#d03484] to-[#d47254] text-white shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
        >
          <MessageCircle size={28} />
        </button>
      )}
    </div>
  );
}